import React from 'react'
import { fromJSX, Updater, Widget } from 'widgets-for-react'
import { PageWithBlocksState } from '../cmsPage/cmsPageState'

export const authorAndPhotographerWidget = (
  author: string,
  photographer: string
): Widget<Updater<PageWithBlocksState>> => {
  return fromJSX(() => (
    <>
      {author && <AuthorAndPhotographerLayout label={'Tekst'} name={author} />}
      {photographer && <AuthorAndPhotographerLayout label={'Beeld'} name={photographer} />}
    </>
  ))
}

const AuthorAndPhotographerLayout = (props: {
  label: string
  name: string
}) => {
  return (
    <div className="block block--text">
      <div className="block__inner container--s gutter--m spacing--m">
        <div className="block__content">
          <div className="block__text text--styled">
            <label>{props.label}</label>
            <p className="name__highlight">{props.name}</p>
          </div>
        </div>
      </div>
    </div>
  )
}
